export const VO = {
    DOSSIER_VENTA: {
        GetExpedientById: 'Services/VO/VOExpedientsService.svc/GetExpedientById',
        GetExpedientsInProgress: 'Services/VO/VOExpedientsService.svc/GetExpedientsInProgress',
        GetExpedientsReserved: 'Services/VO/VOExpedientsService.svc/GetExpedientsReserved',
        GetExpedientsClosed: 'Services/VO/VOExpedientsService.svc/GetExpedientsClosed',
        GetByCustomerCode: 'Services/General/CustomerService.svc/GetByCustomerCode',
        GetInvoicesHeaderByVOExpedientID: 'Services/VO/VOInvoicesService.svc/GetInvoicesHeaderByVOExpedientID',
        GetAllVehicleBrands: 'Services/Workshop/VehicleBrandService.svc/GetAllVehicleBrands',
        GetAllCustomer: 'Services/General/CustomerService.svc/GetAllCustomer',
        GetInvoiceById: 'Services/VO/VOInvoicesService.svc/GetInvoiceById',
        CancelReserveExpedientByID: 'Services/VO/VOExpedientsService.svc/CancelReserveExpedientByID',
        UpdateExpedientCustomer: 'Services/VO/VOExpedientsService.svc/UpdateExpedientCustomer',
        UpdateExpedientInvoiceCustomer: 'Services/VO/VOExpedientsService.svc/UpdateExpedientInvoiceCustomer',
        Find: 'Services/General/AgentsService.svc/Find',
        GetAllReceptionists: 'Services/WareHouse/ReceptionistService.svc/GetAllReceptionists',
        GetAll: 'Services/VO/VOCarTypesService.svc/GetAll',
        GetAllVOTaxDeductions: 'Services/VO/VOTaxDeductionsService.svc/GetAll',
        UpdateExpedientDossier: 'Services/VO/VOExpedientsService.svc/UpdateExpedientDossier',
        CreateImplementInvoiceByParams: 'Services/VO/VOInvoicesService.svc/CreateImplementInvoiceByParams',
        AddDetailImplement: 'Services/VO/VOInvoicesService.svc/AddDetailImplement',
        CreateFeatureInvoiceByParams: 'Services/VO/VOInvoicesService.svc/CreateFeatureInvoiceByParams',
        AddDetailComplement: 'Services/VO/VOInvoicesService.svc/AddDetailComplement',
        CreateSuppliedInvoiceByParams: 'Services/VO/VOInvoicesService.svc/CreateSuppliedInvoiceByParams',
        AddDetailSupplied: 'Services/VO/VOInvoicesService.svc/AddDetailSupplied',
        UpdateInvoiceNotes: 'Services/Invoicing/SalesInvoicesService.svc/UpdateInvoiceNotes',
        DeleteDetailById: 'Services/VO/VOInvoicesService.svc/DeleteDetailById',
        UpdateDetailByParams: 'Services/VO/VOInvoicesService.svc/UpdateDetailByParams',
        CreateVOInvoiceByParams: 'Services/VO/VOInvoicesService.svc/CreateVOInvoiceByParams',
        UpdateDetailVOByParams: 'Services/VO/VOInvoicesService.svc/UpdateDetailVOByParams',
        DeleteInvoiceById: 'Services/VO/VOInvoicesService.svc/DeleteInvoiceById ',
        calculateFromImporteNetoSpecialRegime: 'Services/VO/VOInvoicesService.svc/CalculateFromImporteNetoSpecialRegime',
        calculateFromInvoiceTotalSpecialRegime: 'Services/VO/VOInvoicesService.svc/CalculateFromInvoiceTotalSpecialRegime',
        calculateFromPlusvaliaIVAGeneralRegime: 'Services/VO/VOInvoicesService.svc/CalculateFromPlusvaliaIVAGeneralRegime',
        GetCurrentProductionOrder: 'Services/Workshop/VehicleService.svc/GetCurrentProductionOrder',
        BillExpedientByID: 'Services/VO/VOInvoicesService.svc/BillExpedientByID',
        GetNewReceiptNumber: 'Services/VO/VOInvoicesService.svc/GetNewReceiptNumber',
        CreateVOReceipt: 'Services/VO/VOInvoicesService.svc/CreateVOReceipt',
        UpdateVOReceipt: 'Services/VO/VOInvoicesService.svc/UpdateVOReceipt',
        DeleteVOReceipt: 'Services/VO/VOInvoicesService.svc/DeleteVOReceipt'
    },
    RECEPCION_VO: {
        GetExpedientsOpened: 'Services/VO/VOExpedientsService.svc/GetExpedientsOpened',
        GetExpedientsCancelledOnOpen: 'Services/VO/VOExpedientsService.svc/GetExpedientsCancelledOnOpen',
        GetCurrentByChassis: 'Services/Workshop/VehicleValuationService.svc/GetCurrentByChassis',
        CancelOpenedExpedientByID: 'Services/VO/VOExpedientsService.svc/CancelOpenedExpedientByID',
        ReactivateExpedientByID: 'Services/VO/VOExpedientsService.svc/ReactivateExpedientByID',
        UpdateVehicleByParams: 'Services/VO/WorkshopVehiclesService.svc/UpdateVehicleByParams',
        UpdateExpedientCustomer: 'Services/VO/VOExpedientsService.svc/UpdateExpedientCustomer',
        GetAllVehicleVOStates: 'Services/VO/VOExpedientsService.svc/GetAllVehicleVOStates',
        GetOriginVOCarType: 'Services/VO/VOCarTypesService.svc/GetOriginVOCarType',
        GetDestinationVOCarType: 'Services/VO/VOCarTypesService.svc/GetDestinationVOCarType',
        VOVehiclesStatusService: 'Services/VO/VOVehiclesStatusService.svc/GetAll',
        GetSmallReceptionists: 'Services/WareHouse/ReceptionistService.svc/GetSmallReceptionists',
        UpdateExpedientValuation: 'Services/VO/VOExpedientsService.svc/UpdateExpedientValuation',
        VehicleValuationServiceAdd: 'Services/Workshop/VehicleValuationService.svc/Add',
        VehicleValuationServiceUpdate: 'Services/Workshop/VehicleValuationService.svc/Update',
        AcceptExpedientByParams: 'Services/VO/VOExpedientsService.svc/AcceptExpedientByParams'
    },
    GESTION_VO: {
        STEP1: {
            GetExpedientsReservedInProgress: 'Services/VO/VOExpedientsService.svc/GetExpedientsReservedInProgress',
            GetExpedientsReserved: 'Services/VO/VOExpedientsService.svc/GetExpedientsReserved',
            GetExpedientsCancelledOnProgress: 'Services/VO/VOExpedientsService.svc/GetExpedientsCancelledOnProgress',
            GetExpedientsClosed: 'Services/VO/VOExpedientsService.svc/GetExpedientsClosed',
            GetExpedientById: 'Services/VO/VOExpedientsService.svc/GetExpedientById',
            GetExpedientsAborted: 'Services/VO/VOExpedientsService.svc/GetExpedientsAborted'
        },
        STEP2: {
            CancelInProgressExpedientByID: 'Services/VO/VOExpedientsService.svc/CancelInProgressExpedientByID',
            ReacceptExpedientByID: 'Services/VO/VOExpedientsService.svc/ReacceptExpedientByID',
            AbortOpenedExpedientByID: 'Services/VO/VOExpedientsService.svc/AbortOpenedExpedientByID',
            CreateCorrectiveTransferInvoice: 'Services/VO/VOInvoicesService.svc/CreateCorrectiveTransferInvoice',
            CreateCorrectivePurchaseInvoice: 'Services/Invoicing/PurchaseInvoicesService.svc/CreateCorrectivePurchaseInvoice'
        },
        STEP4: {
            CreateTransferInvoice: 'Services/VO/VOInvoicesService.svc/CreateTransferInvoice',
            DeletePurchaseInvoicesByID: 'Services/VO/VOInvoicesService.svc/DeletePurchaseInvoicesByID',
            UpdateTransferInvoice: 'Services/VO/VOInvoicesService.svc/UpdateTransferInvoice',
            GetAllVatTypes: 'Services/General/VatTypeService.svc/GetAll',
            CreatePurchaseInvoiceSimulated: 'Services/VO/VOInvoicesService.svc/CreatePurchaseInvoiceSimulatedByParams',
            CreatePurchaseInvoice: 'Services/VO/VOInvoicesService.svc/CreatePurchaseInvoiceByParams',
            UpdatePurchaseInvoiceByParams: 'Services/VO/VOInvoicesService.svc/UpdatePurchaseInvoiceByParams'

        },
        Adequation: {
            FindByCodeAndDescription: 'Services/VO/VOAdequacyCostTypesService.svc/FindByCodeAndDescription',
            InputAdeqCost: 'Services/VO/VOAdequacyCostService.svc/InputAdeqCost',
            DeleteAdeqCost: 'Services/VO/VOAdequacyCostService.svc/DeleteAdeqCost'
        },
        OR: {
            UpdateExpedientPOCost: 'Services/VO/VOORCostService.svc/UpdateExpedientPOCost',
            Or: 'Services/Workshop/RepairOrderService.svc/GetByProductionOrderNumberComplete'
        },
        EditVehicle: {
            GetCurrentByChassis: 'Services/Workshop/VehicleValuationService.svc/GetCurrentByChassis',
            updateValuation: 'Services/Workshop/VehicleValuationService.svc/Update',
            updateExpedient: 'Services/VO/VOExpedientsService.svc/UpdateExpedient'
        },
        adjuntarDoc: {
            UpdateExpedientMediaFileList: 'Services/VO/VOExpedientsService.svc/UpdateExpedientMediaFileList'

        }

    },
    HOME: {
        VOHistory: "Services/VO/VOHomeService.svc/VOHistory",
        GetSummaryByYear: "Services/VO/VOHomeService.svc/GetSummaryByYear"
    }


}


